export const INLINE_HIGHLIGHTS_BEST_EFFORT_TASK_NAME = 'InlineHighlightsQuery';
